import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import person4 from '../../static/person4.webp'
import person5 from '../../static/person5.webp'
import person6 from '../../static/person6.webp'



const BoardMembers: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>理事会、监事会成员信息</h1>
                <div className='members-carousel'>
                    <Slider dots infinite speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={2000}>
                        <div className='member-card'>
                            <img src={person4} alt='人物1' className='member-photo' />
                            <h1>杜  平</h1>
                            <h5>理事长</h5>
                            <p>浙江绿城爱心教育基金会理事长。毕业于杭州大学，获文学学士学位。于1990年7月参加工作，入职杭州日报社，先后担任记者、主任记者、首席记者、文体部主任、财经新闻中心主任、编委委员。2015年3月9日加入绿城集团，于2016年7月获委任为绿城中国副总裁。</p>
                        </div>
                        <div className='member-card'>
                            <img src={person5} alt='人物2' className='member-photo' />
                            <h1>尚书臣</h1>
                            <h5>副理事长</h5>
                            <p>曾任绿城中国董事会秘书（经营班子成员）、兼任董事会办公室主任、总裁办公室主任、党群办公室主任。尚先生毕业于辽宁青年管理干部学院、沈阳农业大学，拥有硕士学位。尚先生曾任辽宁省庄河市团委书记、工会主席、纪委书记、市委副书记、市政府常务副市长，大连循环产业经济区党工委副书记、管委会副主任，大连市委组织部副部长，大连金普新区党工委委员、管委会副主任兼大连金石滩国家旅游度假区党组书记、管委会主任等职务，在组织建设、干部和人才管理、行政管理等方面拥有丰富的经验。尚先生于2019年4月加入绿城集团，获委任为党群办公室主任，于2019年12月16日获委任为董事会办公室主任（兼）、总裁办公室主任（兼），于2020年3月20日获委任为绿城中国董事会秘书、浙江绿城爱心教育基金会副理事长。</p>
                        </div>
                        <div className='member-card'>
                            <img src={person6} alt='人物3' className='member-photo' />
                            <h1>刘  虹</h1>
                            <h5>秘书长</h5>
                            <p>浙江绿城爱心教育基金会秘书长、郁金香陪伴创始人、国家二级心理咨询师,毕业于浙江大学。</p>
                        </div>
                    </Slider>
                </div>
                <div className='members-info'>
                    <h2 className='section-title'>成员信息</h2>
                    <div className='info-card'>
                        <h3>理事长</h3>
                        <h5>杜平</h5>
                        <p>浙江绿城爱心教育基金会理事长。毕业于杭州大学，获文学学士学位。于1990年7月参加工作，入职杭州日报社，先后担任记者、主任记者、首席记者、文体部主任、财经新闻中心主任、编委委员。2015年3月9日加入绿城集团，于2016年7月获委任为绿城中国副总裁。</p>
                    </div>
                    <div className='info-card'>
                        <h3>副理事长</h3>
                        <h5>尚书臣</h5>
                        <p>曾任绿城中国董事会秘书（经营班子成员）、兼任董事会办公室主任、总裁办公室主任、党群办公室主任。毕业于辽宁青年管理干部学院、沈阳农业大学，拥有硕士学位。曾任辽宁省庄河市团委书记、工会主席、纪委书记、市委副书记、市政府常务副市长，大连循环产业经济区党工委副书记、管委会副主任，大连市委组织部副部长，大连金普新区党工委委员、管委会副主任兼大连金石滩国家旅游度假区党组书记、管委会主任等职务，在组织建设、干部和人才管理、行政管理等方面拥有丰富的经验。2019年4月加入绿城集团，获委任为党群办公室主任，于2019年12月16日获委任为董事会办公室主任（兼）、总裁办公室主任（兼），于2020年3月20日获委任为绿城中国董事会秘书、浙江绿城爱心教育基金会副理事长。</p>
                    </div>
                    <div className='info-card'>
                        <h3>秘书长</h3>
                        <h5>刘虹</h5>
                        <p>浙江绿城爱心教育基金会秘书长、郁金香陪伴创始人、国家二级心理咨询师,毕业于浙江大学。</p>
                    </div>
                    <div className='info-card'>
                        <h3>理事</h3>
                        <h5>陈红伟</h5>
                        <p>绿城中国财务资金中心总经理</p>
                        <h5>张骥</h5>
                        <p>绿城中国发展投资中心总经理</p>
                        <h5>焦凤波</h5>
                        <p>浙江职业足球俱乐部有限公司总经理</p>
                        <h5>陈芳</h5>
                        <p>杭州郁金香助医公益服务中心工作人员</p>
                        <h5>嵇哲</h5>
                        <p>绿城中国董办、党群办副主任</p>
                    </div>
                    <div className='info-card'>
                        <h3>监事</h3>
                        <h5>王胜辉</h5>
                        <p>绿城中国董事会办公室执行主任、总裁办公室执行主任</p>
                    </div>
                </div>
            </div>
        } />
    );
};

export default BoardMembers;